import { SubscriptionInfo, useCancelSubscription } from "services/rest/subscription";
import { Button, Modal, notification } from "antd";
import { CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { DateUtils } from "services/utils/DateUtils";
import React from "react";
import { useIntl } from "react-intl";

export type CancelRenewalButtonProps = {
  subscription: SubscriptionInfo,
  onAfter: () => void,
}

export function CancelRenewalButton(props: CancelRenewalButtonProps) {
  const { subscription, onAfter } = props;
  const { id, nextPayment } = subscription;
  const intl = useIntl();

  const { fetch } = useCancelSubscription(id);

  const cancelRenewalModal = () => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined style={{ color: "#FC1264" }} />,
      title: intl.formatMessage({ id: "jmix-store.cancel-renewal-button.modal.title" }),
      content: intl.formatMessage(
        { id: "jmix-store.cancel-renewal-button.modal.content" },
        { date: DateUtils.getFormatDate(nextPayment.date) }
      ),
      centered: true,
      okButtonProps: { title: intl.formatMessage({ id: "jmix-store.modal.action.confirm" }) },
      cancelButtonProps: { icon: <CloseOutlined /> },
      onOk() {
        fetch()
          .then(() => {
            notification.success({
              message: intl.formatMessage({ id: "jmix-store.cancel-renewal-button.success" }),
            });

            onAfter();
          })
          .catch(() => {
            notification.error({
              message: intl.formatMessage({ id: "jmix-store.cancel-renewal-button.error" }),
            });
          });
      },
    });
  };

  return (
    <Button
      type="primary"
      ghost
      onClick={cancelRenewalModal}
    >
      {intl.formatMessage({ id: "jmix-store.cancel-renewal-button.name" })}
    </Button>
  );
}